module.exports = __webpack_public_path__ + "img/img-404.20398406.png";